// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-icon-22e1","primary":"Icon-primary-22e1","secondary":"Icon-secondary-22e1","tertiary":"Icon-tertiary-22e1","error":"Icon-error-22e1","success":"Icon-success-22e1"};